<script lang="ts">
	import type { LearningPath } from '$lib/types/hygraph';
	import { classes } from '$lib/utils';
	import { fade } from 'svelte/transition';
	import FeatureCard from '../Card/FeatureCard.svelte';
	import type { EntryIcon } from '../Entries/Entry';

	export let timeToComplete: LearningPath['timeToComplete'];
	export let skillLevel: LearningPath['skillLevel'];
	export let prerequisites: string[];

	export let elementId: string = '';
	export let additionalClass: string = '';
	export let enableAnimation: boolean = false;

	let skillLevelIcon: EntryIcon = `skillLevel${skillLevel ?? 'Advanced'}`;
</script>

<div
	transition:fade|local
	id={elementId}
	class={classes(
		additionalClass,
		`flex flex-col transition-all duration-300  ${
			enableAnimation ? 'gradient-background  background-gradient' : 'bg-white'
		} md:flex-row gap-28 2xl:gap-4 rounded-lg mt-16 py-6 px-11 2xl:px-[10%] justify-between`
	)}
>
	<FeatureCard
		titleTolgeeKey="skillLevel"
		features={[{ icon: skillLevelIcon, text: skillLevel }]}
	/>

	{#if timeToComplete}
		<FeatureCard
			titleTolgeeKey="timeToComplete"
			features={[{ icon: 'timeToComplete', text: timeToComplete }]}
		/>
	{/if}

	{#if prerequisites?.length}
		<FeatureCard
			titleTolgeeKey="prerequisites"
			features={prerequisites.map((text) => ({ icon: 'prerequisite', text }))}
		/>
	{/if}

	<!-- TODO: Implement so that it is dynamic again -->
	<!-- {#if featureCards?.length}
		{#each featureCards as featureCard} -->
	<!-- Checks if any of the requisites/features contains a description - otherwise won't show -->
	<!-- {#if featureCard.features.length && featureCard.features.every((feature) => feature.text)}{/if}
		{/each}
	{/if} -->
</div>
